<template>
  <div class="sendMailInfo">
    <div class="searchForm">
      <el-form ref="form" :model="form" label-width="70px" @submit.native.prevent>
        <el-row>
          <el-col :span="24">
            <el-form-item label="查询条件">
              <el-input v-model="form.mail" autocomplete="off" placeholder="请输入邮箱"
                        @keyup.enter.native="getSendMailList(1)"/>
            </el-form-item>
            <el-button type="primary" style="margin-left: 30px;" @click="getSendMailList(1)">查询</el-button>
            <!-- <el-button type="primary" @click="showEditDialog(0)">申请</el-button> -->
            <el-button type="primary" @click="showEditDialog(2)">新增</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="dataBox">
      <el-table v-loading="loading" element-loading-text="数据加载中" :data="tableData" stripe  max-height="700">
        <el-table-column prop="mail" label="发件箱"/>
         <el-table-column prop="principal" label="申请人"/>
        <el-table-column prop="agentId" label="企微应用ID"/>
        <el-table-column show-overflow-tooltip prop="token" label="企微应用密钥"/> 
        <el-table-column prop="corpAmount" label="企微公司规模"/>
        <el-table-column prop="emailAmount" label="企微邮箱购买人数"/>
        <el-table-column prop="createDate" sortable label="申请时间">
          <template slot-scope="scope">
            <span>{{ parseTime(scope.row.createDate) }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" fixed="right" width="250">
          <template slot-scope="scope">
            <el-button type="text" @click="showEditDialog(1, scope.row)">修改</el-button>
            <el-button type="text" @click="testMailDialog(scope.row)" v-if="scope.row.status===2">测试</el-button>
            <el-popconfirm
                @confirm="deleteMail(scope.row)"
                icon="el-icon-info"
                icon-color="red"
                title="确认删除发件箱吗？"
                style="margin-left: 0.625rem"
            >
              <el-button type="text" slot="reference">删除</el-button>
            </el-popconfirm>
          </template>

        </el-table-column>

      </el-table>
      <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :page-sizes="[10,20,50]"
          :page-size="pageSize"
          :current-page.sync="pageNum"
          @size-change="sizeChangeClick"
          @current-change="currChangeClick"
          @prev-click="prevClick"
          @next-click="nextClick"
      />
    </div>
    <!-- 编辑弹框 -->
    <el-dialog :title="operateType === 1?'编辑':'新增' "
               :visible.sync="dialogEditFormVisible" width="50%"
               :before-close="closeDialog">
      <el-form :model="editForm" ref="editForm" label-width="160px" :rules="rules">
        <el-form-item label="发件箱" prop="mail">
          <el-input v-model="editForm.mail" placeholder="请输入发件箱" :disabled="operateType===1"/>
        </el-form-item>
        <el-form-item label="申请人" prop="principal">
          <el-input v-model="editForm.principal" placeholder="请输入申请人" />
        </el-form-item>
        <el-form-item label="企微应用ID" prop="agentId">
          <el-input v-model="editForm.agentId" placeholder="请输入企微应用ID" :disabled="operateType===1"/>
        </el-form-item>
         <el-form-item label="企微应用密钥" prop="token">
          <el-input v-model="editForm.token" placeholder="请输入企微应用密钥" :disabled="operateType===1"/>
        </el-form-item>
         <el-form-item label="企微公司规模" prop="corpAmount">
          <el-input v-model="editForm.corpAmount" placeholder="请输入企微公司规模"/>
        </el-form-item>
        <el-form-item label="企微邮箱购买人数" prop="emailAmount">
          <el-input v-model="editForm.emailAmount" placeholder="请输入企微邮箱购买人数"/>
        </el-form-item>
        <el-form-item label="备注" prop="description">
          <el-input v-model="editForm.description" placeholder="请输入备注" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogEditSave" :loading="saveLoading">保存</el-button>
        <el-button type="primary" @click="closeDialog">取消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="发件箱测试" width="50%" :visible.sync="dialogMailFormVisible">
      <el-form :model="mailForm" ref="mailForm" :rules="mailRules" label-width="100px">
        <el-form-item prop="receive" label="收件人">
          <el-input v-model="mailForm.receive" placeholder="请输入收件人邮箱"/>
        </el-form-item>
        <el-form-item prop="title" label="邮件标题">
          <el-input v-model="mailForm.title" placeholder="请输入邮件标题"/>
        </el-form-item>
        <el-form-item prop="content" label="邮件内容">
          <el-input type="textarea" rows="5" v-model="mailForm.content" placeholder="请输入邮件内容"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sendMail" :loading="saveLoading">发送</el-button>
        <el-button @click="closeMailDialog">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import EditorBar from '@/components/editor';
import {parseTime} from "@/util/index";
import httpUrl from "@/static/configUrl";
const initForm = {
  clientId: '',
  id: '',
  mail: '',
  agentId:'',
  token: '',
  principal: '',
  corpAmount: '',
  emailAmount: undefined,
  description: '',
  mailClientId: ''
}
export default {
  name: 'sendMailInfo',
  components: {
    EditorBar
  },
  data() {
    return {
      // clientId: this.$store.state.request.appId,
      form: {
        mail: ''
      },
      tableData: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      loading: false,
      dialogEditFormVisible: false,
      dialogMailFormVisible: false,
      saveLoading: false,
      applyLoading: false,
      operateType: 0,
      doAdminAccount: '',
      appList: [],
      // 编辑的form表单
      editForm: {...initForm},
      mailForm: {
        clientId: this.$store.state.request.appId,
        sendMail: '',
        title: '',
        content: '',
        receive: ''
      },
      dialogFormVisible: false,
      visible: false,
      rules: {
        mail: [
          {required: true, message: '请输入发件箱', trigger: ['blur','change']}
        ],
        agentId:[
          {required: true, message: '请输入企微应用ID', trigger: ['blur','change']},
          {pattern: /^\d+$/, message: '企微应用ID必须为数字', trigger: ['blur','change']}
        ],
        token:[
          {required: true, message: '请输入企微应用密钥', trigger: ['blur','change']}
        ],
        corpAmount:[
          {required: true, message: '请输入企微公司规模', trigger: ['blur','change']},
          {pattern: /^\d+$/, message: '企微公司规模必须为数字', trigger: ['blur','change']}
        ],
        emailAmount:[
          {pattern: /^\d+$/, message: '企微邮箱购买人数必须为数字', trigger: ['blur','change']}
        ],
      },
      mailRules: {
        title: [
          {required: true, message: '请输入邮件标题', trigger: 'blur'}
        ],
        content: [
          {required: true, message: '请输入邮件内容', trigger: 'blur'}
        ],
        receive: [
          {required: true, message: '请输入收件人', trigger: 'blur'}
        ],

      }
    }
  },
  computed: {
    clientId(){
      return this.$store.state.request.appId
    }
  },
  watch:{
    clientId() {
      this.getSendMailList()
    }
  },
  created() {
    // this.doAdminAccount = this.$store.state.Login.userInfo.domainAccount
    this.getSendMailList()
  },
  mounted() {

  },
  methods: {
    parseTime,
    getSendMailList(_pageNum) {
      const that = this
      if (_pageNum === 1) {
        that.pageNum = 1
      }
      that.loading = true
      const _data = {
        curl: httpUrl.messageUrl + "/mail/list",
        mailClientId: that.clientId,
        mail: that.form.mail,
        page: that.pageNum,
        size: that.pageSize
      }
      that.$store.dispatch('httpGet', _data).then(function (res) {
        that.tableData = res.data.content
        that.total = parseInt(res.data.total)
        that.loading = false
      }, function (err) {
        console.log(err.message)
        that.loading = false
      })
    },
    appListSearch() {
      const that = this
      const _data = {
        curl: httpUrl.paasUrl + '/approve/projectList'
      }
      that.loading = true
      that.$store.dispatch('httpGet', _data).then(function (res) {
        that.appList = res.data
        that.loading = false
      }, function (err) {
        console.log(err.message)
        that.loading = false
      })
    },
    // 分页 每页条数改变
    sizeChangeClick(val) {
      this.pageSize = val
      this.getSendMailList()
    },
    // 分页 改变当前页
    currChangeClick(val) {
      this.pageNum = val
      this.getSendMailList()
    },
    // 分页 上一页
    prevClick(val) {
      this.pageNum = val
      this.getSendMailList()
    },
    // 分页 下一页
    nextClick(val) {
      this.pageNum = val
      this.getSendMailList()
    },
    // 编辑-弹出窗
    showEditDialog(operType, rowData) {
      // this.appListSearch()
      this.editForm = {
        ...initForm,
        clientId: this.clientId,
        mailClientId: ''
      }

      this.operateType = operType
      if (operType === 1) {
        this.editForm = {
          clientId: this.clientId,
          ...rowData
        }
      }
      this.dialogEditFormVisible = true
    },
    // 测试发件箱 发邮件
    testMailDialog(rowData) {
      const that = this
      this.mailForm = {
        clientId: that.clientId,
        sendMail: rowData.mail,
        title: '',
        content: '',
        receive: ''
      }
      this.dialogMailFormVisible = true
    },
    // 编辑-保存
    dialogEditSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          const that = this
          that.saveLoading = true
          let _funName = '/mail/apply'
          let httpType = 'httpPost'
          if (that.operateType === 1) {
            _funName = '/mail/update'
            httpType = 'httpPut'
          }
          if (that.operateType === 2) {
            _funName = '/mail/add'
          }
          this.$set(this.editForm, 'curl', httpUrl.messageUrl + _funName)
          that.$store.dispatch(httpType, that.editForm).then(function (res) {
                that.saveLoading = false
                that.$message({
                  message: res.message,
                  type: 'success',
                  duration: 500,
                  onClose: function () {
                    that.dialogEditFormVisible = false
                    that.getSendMailList()
                  }
                })
              }, function (err) {
                that.saveLoading = false
              }
          )
          return true
        } else {
          return false
        }
      })
    },
    closeDialog() {
      this.dialogEditFormVisible = false;
      this.$refs['editForm'].clearValidate();
    },
    sendMail() {
      this.$refs['mailForm'].validate((valid) => {
        if (valid) {
          const that = this
          that.saveLoading = true
          let _funName = '/mail/test/send'
          let httpType = 'httpPost'
          this.$set(this.mailForm, 'curl', httpUrl.messageUrl + _funName)
          that.$store.dispatch(httpType, that.mailForm).then(function (res) {
                that.saveLoading = false
                that.$message({
                  message: '发送成功',
                  type: 'success',
                  duration: 500,
                })
              }, function (err) {
                that.saveLoading = false
              }
          )
          return true
        } else {
          return false
        }
      })
    },
    closeMailDialog() {
      this.dialogMailFormVisible = false;
      this.$refs['mailForm'].clearValidate();
    },
    deleteMail(rowData) {
      const that = this
      let _funName = '/mail/delete/' + rowData.id
      let httpType = 'httpDelete'
      const param = {}
      this.$set(param, 'curl', httpUrl.messageUrl + _funName)
      that.$store.dispatch(httpType, param).then(function (res) {
            that.$message({
              message: res.message,
              type: 'success',
              duration: 500,
              onClose: function () {
                that.getSendMailList()
              }
            })
          }, function (err) {
            // that.saveLoading = false
          }
      )
    }
  }
}

</script>

<style lang="scss" scoped>
.sendMailInfo {
  .searchForm {
    padding-left: 10px;

    .el-input {
      width: 200px;
    }
  }

}
</style>
<style>
.sendMailInfo .searchForm .el-form-item {
  display: inline-block;
}

.sendMailInfo .searchForm .el-form-item:nth-child(2) {
  margin-left: 30px;
}
</style>
